import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";

/**
 * Contextual breadcrumb linking closely-related pages (e.g. Kode Arduino ↔ ESP32 Wizard).
 * Renders a subtle inline pill above the PageHeader to guide the user across the linked flow.
 *
 * Props:
 *   - from: string label of the current page (e.g. "Kode Arduino")
 *   - to: { label, href, description? }
 */
export default function PageCrossLink({ from, to }) {
  return (
    <div
      className="mb-3 flex items-center flex-wrap gap-2 text-xs"
      data-testid="page-cross-link"
    >
      <span className="text-muted-foreground uppercase tracking-wider">{from}</span>
      <ChevronRight className="w-3 h-3 text-muted-foreground/60" />
      <Link
        to={to.href}
        data-testid="page-cross-link-target"
        className="group inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-primary/30 bg-primary/5 text-primary hover:bg-primary/10 hover:border-primary/50 transition-colors"
      >
        <span className="font-medium">{to.label}</span>
        <ArrowRight className="w-3 h-3 opacity-70 group-hover:translate-x-0.5 transition-transform" />
      </Link>
      {to.description && (
        <span className="text-muted-foreground italic hidden sm:inline">
          {to.description}
        </span>
      )}
    </div>
  );
}
